export const MIN_SHARPNESS = 75;
export const MIN_GLARE = 55;
export const MAX_TRIES_BEFORE_UPLOAD = 1;
